import React, { useState } from 'react';
import { format } from 'date-fns';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Calendar } from '../ui/calendar';
import { usePortalContainer } from './PortalContainerContext';

const DatePickerButton = ({ label, onPick, selectedDate, fromYear, toYear }) => {
  const [open, setOpen] = useState(false);
  const portalContainer = usePortalContainer();

  // Default year range: 10 years back to 10 years forward
  const currentYear = new Date().getFullYear();
  const defaultFromYear = fromYear || currentYear - 10;
  const defaultToYear = toYear || currentYear + 10;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="h-10 w-full text-left text-sm border-ui-line focus:border-ui-violet-solid focus:ring-ui-violet-solid px-3 rounded-md border bg-ui-surface hover:bg-ui-hover"
        >
          {label || 'Select date'}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" container={portalContainer}>
        <Calendar
          mode="single"
          selected={selectedDate}
          defaultMonth={selectedDate || new Date()}
          onSelect={(date) => {
            // Clicking the already-selected day emits undefined (a deselect
            // toggle); treat it as re-picking that day instead of clearing.
            const picked = date || selectedDate;
            if (onPick && picked) onPick(picked);
            setOpen(false);
          }}
          captionLayout="dropdown-buttons"
          fromYear={defaultFromYear}
          toYear={defaultToYear}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default DatePickerButton;
